import { render, staticRenderFns } from "./PlatformDescription.vue?vue&type=template&id=2ccb1d56&scoped=true"
import script from "./PlatformDescription.vue?vue&type=script&lang=js"
export * from "./PlatformDescription.vue?vue&type=script&lang=js"
import style0 from "./PlatformDescription.vue?vue&type=style&index=0&id=2ccb1d56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ccb1d56",
  null
  
)

export default component.exports